const getPreviewPlaylistOrientation = () => localStorage.getItem('playlistOrientation')

const setPreviewPlaylistOrientation = (orientation: string) => {
  localStorage.setItem('playlistOrientation', orientation)
}

export { getPreviewPlaylistOrientation, setPreviewPlaylistOrientation }
